import Vue from 'vue'
import Router from 'vue-router'
// import Layout from '@/Layout/'
// import axios from '@/request/index.js'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/views/index'),
    name: 'Dashboard',
    meta: { title: '首页', icon: 'index', affix: true, noCache: true }
  },
  {
    path: '/shopList',
    component: () => import('@/views/shopList'),
    name: 'ShopList',
    meta: { title: '首页', icon: 'index', affix: true, noCache: true }
  },
  {
    path: '/orderList',
    component: () => import('@/views/orderList'),
    name: 'OrderList',
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/shoppingCart',
    component: () => import('@/views/shoppingCart'),
    name: 'ShoppingCart',
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/orderDetail:status',
    component: () => import('@/views/orderDetail'),
    name: 'OrderDetail',
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/shopDetail:id',
    component: () => import('@/views/shopDetail'),
    name: 'ShopDetail',
    meta: { title: '我的订单', icon: 'index', affix: true, noCache: true }
  },
  {
    path: '/mailList',
    component: () => import('@/views/mailList'),
    name: 'MailList',
    meta: {
      requireAuth: true // 需要验证登录状态
    }
  },
  {
    path: '/brandList',
    component: () => import('@/views/brandList'),
    name: 'BrandList',
    meta: { title: '我的订单', icon: 'index', affix: true, noCache: true }
  },
  {
    path: '/operatorManager',
    component: () => import('@/views/operatorManager'),
    name: 'OperatorManager',
    meta: { title: '操作员管理', icon: 'index', affix: true, noCache: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../components/Error.vue')
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js